"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Code = exports.P = exports.H4 = exports.H3 = exports.H2 = exports.H1 = void 0;

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledComponentsModifiers = require("styled-components-modifiers");

var _designTokens = require("@decisiv/design-tokens");

var _spacing = _interopRequireDefault(require("../../modifiers/spacing"));

var _utils = require("../../utils");

var _schema = _interopRequireDefault(require("./schema"));

var _withColors = _interopRequireDefault(require("./withColors"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var truncateModifier = (0, _utils.applyDynamicModifiers)('truncate', function (_ref) {
  var truncate = _ref.truncate;
  return truncate ? (0, _styledComponents.css)(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]) : '';
});
var weightModifiers = (0, _utils.applyDynamicModifiers)('weight', function (_ref2) {
  var weight = _ref2.weight;
  return (0, _styledComponents.css)(["font-weight:", ";"], _designTokens.typography.weight.alias[weight]);
}); // This uses the full path instead of the const defined above to
// prevent TS from complaining about using private names.

var typographyBase = (0, _styledComponents.css)(["font-weight:", ";padding:0;margin:0;", ";", ";", ";", ";"], _designTokens.typography.weight.alias.default, _spacing.default, _withColors.default, truncateModifier, weightModifiers);

var H1 = _styledComponents.default.h1.withConfig({
  displayName: "Typography__H1",
  componentId: "sc-1nbtkep-0"
})(["", ";font-size:", ";line-height:120%;"], typographyBase, (0, _rem.default)(_designTokens.typography.size.alias.header1)); // @ts-ignore


exports.H1 = H1;
H1.propTypes = _schema.default.propTypes;

var H2 = _styledComponents.default.h2.withConfig({
  displayName: "Typography__H2",
  componentId: "sc-1nbtkep-1"
})(["", ";font-size:", ";line-height:120%;"], typographyBase, (0, _rem.default)(_designTokens.typography.size.alias.header2)); // @ts-ignore


exports.H2 = H2;
H2.propTypes = _schema.default.propTypes;

var H3 = _styledComponents.default.h3.withConfig({
  displayName: "Typography__H3",
  componentId: "sc-1nbtkep-2"
})(["", ";font-size:", ";line-height:120%;"], typographyBase, (0, _rem.default)(_designTokens.typography.size.alias.header3)); // @ts-ignore


exports.H3 = H3;
H3.propTypes = _schema.default.propTypes;

var H4 = _styledComponents.default.h4.withConfig({
  displayName: "Typography__H4",
  componentId: "sc-1nbtkep-3"
})(["", ";font-size:", ";line-height:120%;"], typographyBase, (0, _rem.default)(_designTokens.typography.size.alias.header4)); // @ts-ignore


exports.H4 = H4;
H4.propTypes = _schema.default.propTypes;
var pSizeModifiers = {
  small: function small() {
    return (0, _styledComponents.css)(["font-size:", ";"], (0, _rem.default)(_designTokens.typography.size.alias.paragraph2));
  }
};

var P = _styledComponents.default.p.withConfig({
  displayName: "Typography__P",
  componentId: "sc-1nbtkep-4"
})(["", ";font-size:", ";line-height:140%;", ";"], typographyBase, (0, _rem.default)(_designTokens.typography.size.alias.paragraph), (0, _styledComponentsModifiers.applyStyleModifiers)(pSizeModifiers, 'size')); // @ts-ignore


exports.P = P;
P.propTypes = _objectSpread({}, _schema.default.propTypes, {
  size: _propTypes.default.oneOf(Object.keys(pSizeModifiers))
});

var Code = _styledComponents.default.pre.withConfig({
  displayName: "Typography__Code",
  componentId: "sc-1nbtkep-5"
})(["font-family:", ";font-size:", ";font-weight:", ";line-height:140%;"], _designTokens.typography.typeface.mono, (0, _rem.default)(_designTokens.typography.size.alias.code), _designTokens.typography.weight.alias.regular);

exports.Code = Code;